
import gql from 'graphql-tag'
// 查询测试
export const getAllUsers = gql`
  query($nameFilter: String) {
    getAllUsers(
      nameFilter: $nameFilter,
    ) {
      id
      username
    }
  }
`
// 修改测试
export const signIn = gql`
  mutation($password: String!, $username: String!) {
    signIn(
      password: $password,
      username: $username
    ) {
      id
    }
  }
`
// """查询订单(经销商)"""
export const findOrder = gql`
  query($orderId: Int!) {
    findOrder(
      orderId: $orderId,
    ) {
      period
      grade
      address {
        avaliable
        className
        createdAt
        isDefault
        phone
        realname
        schoolId
        updatedAt
        year
        school {
          name
          area {
            mergerName
          }
        }
      }
      dealer {
        id
        realname
        storePhone
        storePhone
        user {
          phone
        }
      }
      addressId
      areaId
      bankType
      buyerMessage
      className
      createdAt
      dealerId
      errCode
      errCodeDes
      id
      items {
        id
        title
        count
        price
        author
        thumb
      }
      member {
        id
        nickname
      }
      memberId
      memberUniqueId
      orderNumber
      profitSharing {
        bankType
        id
        profitSharingNumber
      }
      schoolId
      status
      timeEnd
      totalPrice
      tradeType
      updatedAt
      year
      transactionNumber
    }
  }
`

// """查询订单列表(经销商)"""
export const findOrders = gql`
         query(
           $order: [OrdersFindOrder!]
           $paging: PagingQuery
           $where: OrdersFindFilter
         ) {
           findRefundRequiringOrders(
             order: $order
             paging: $paging
             where: $where
           ) {
             orders {
               period
               phone
               realname
               address {
                 className
                 isDefault
                 phone
                 realname
                 schoolId
                 updatedAt
                 year
                 school {
                   name
                   area {
                     mergerName
                   }
                 }
               }
               dealer {
                 id
                 realname
                 storePhone
                 storePhone
                 user {
                   phone
                 }
               }
               refund {
                 auditStatus
                 refundWay
               }
               areaId
               buyerMessage
               className
               createdAt
               dealerId
               errCode
               errCodeDes
               id
               items {
                 id
                 title
                 count
                 price
                 author
                 thumb
               }
               memberId
               member {
                 id
                 nickname
               }
               memberUniqueId
               orderNumber
               transactionNumber
               schoolId
               status
               timeEnd
               totalPrice
               tradeType
               updatedAt
               year
             }
             paging {
               currentOffset
               take
               totalCount
             }
           }
         }
       `
// 查询顶刊周期
export const findAllPeriod = gql`
  query {
    findAllUsedPeriodSettings
  }
`
